import React, { useState } from 'react';

const PickupFilters = ({
  filters,
  handleFilterChange,
  handleDropdownChange,
  handleSearchSubmit,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };
  return (
    <div className="card-body pt-2 filters">
      <div
        onClick={() => setShowFilters((prev) => !prev)}
        style={{
          display: 'inline-block',
          cursor: 'pointer',
          color: '#198754',
          fontWeight: 600,
          borderBottom: '2px solid #198754',
          paddingBottom: '2px',
          userSelect: 'none',
          transition: '0.2s ease',
        }}
      >
        Filters
        <i
          className={`fa fa-chevron-${showFilters ? 'up' : 'down'} ml-2`}
          style={{
            fontSize: '12px',
          }}
        />
      </div>

      {showFilters && (
        <div
          className="d-flex flex-column gap-3 mt-3"
          style={{
            animation: 'fadeIn 0.2s ease',
          }}
        >
          <input
            className="form-control mb-2"
            type="text"
            placeholder="Delivery ID"
            value={filters.id || ''}
            onChange={(e) => handleFilterChange(e, 'id')}
            onKeyDown={handleKeyPress}
          />

          <input
            className="form-control mb-2"
            type="text"
            placeholder="Customer ID"
            value={filters.user_id || ''}
            onChange={(e) => handleFilterChange(e, 'user_id')}
            onKeyDown={handleKeyPress}
          />

          <input
            className="form-control mb-2"
            type="text"
            placeholder="Driver ID"
            value={filters.driver_id || ''}
            onChange={(e) => handleFilterChange(e, 'driver_id')}
            onKeyDown={handleKeyPress}
          />

          <select
            className="form-control mb-2"
            value={filters.delivery_status_id || ''}
            onChange={(e) => handleDropdownChange(e, 'delivery_status_id')}
          >
            <option value="">All statuses</option>

            <option value="0">Not started</option>

            <option value="1">Going to pickup</option>

            <option value="2">At pickup</option>

            <option value="3">Going to dropoff</option>

            <option value="4">At dropoff</option>

            <option value="5">Completed</option>

            <option value="6">Cancelled</option>
          </select>

          <select
            className="form-control mb-2"
            value={filters.paid_status || ''}
            onChange={(e) => handleFilterChange(e, 'paid_status')}
          >
            <option value="paid">Paid</option>
            <option value="unpaid">Unpaid</option>
          </select>

          <button className="btn btn-primary" onClick={handleSearchSubmit}>
            Search
          </button>
        </div>
      )}
    </div>
  );
};

export default PickupFilters;
